export const options = [
    { value: "pre_screening", label: "Pre-screening" },
    { value: "interviewing", label: "Interviewing" },
    { value: "due_diligence", label: "Due diligence" },
    { value: "in_contract", label: "In contract" },
    { value: "completed", label: "Completed" },
    { value: "passed", label: "Passed" },
    { value: "rejected", label: "Rejected" },
    { value: "holding", label: "Holding" },
    { value: "archived", label: "Archived" },
]